import { title as generalTitle } from '../../WaardecheckGeneral';
import { title as designTitle } from '../../WaardecheckDesign';
import { title as verificationTitle } from '../../WaardecheckVerification';
import type { WizardFlow } from '~/graphql/types.client';

type WaardecheckTypename =
  | 'AppStatus_BBWaardecheck'
  | 'AppStatus_VBOWaardecheck';

const getWaardecheckEnablementFlow = (
  typename: WaardecheckTypename,
): WizardFlow => {
  const enableSteps: WizardFlow = {
    id:
      typename === 'AppStatus_BBWaardecheck'
        ? 'enable-bb-waardecheck'
        : 'enable-vbo-waardecheck',
    steps: [
      {
        title: generalTitle,
        id: 'WaardecheckGeneral',
        metadata: { typename },
      },
      {
        title: designTitle,
        id: 'WaardecheckDesign',
        metadata: { typename },
      },
      {
        title: verificationTitle,
        id: 'WaardecheckVerification',
        metadata: { typename },
      },
    ],
  };

  return enableSteps;
};

export default getWaardecheckEnablementFlow;
